var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column w-100 h-100 justify-content-center align-items-center"},[_vm._m(0),_c('div',{staticClass:"font-size-md text-center"},[_c('div',[_vm._v(_vm._s(_vm.$t('warning.notfound')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mw-100 p-5"},[_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/404/Img-404-01@2x.png"),"alt":""}})])
}]

export { render, staticRenderFns }